import { FC } from 'react';
import { Link, navigate } from 'gatsby';
import { useQueryClient } from 'react-query';
import classNames from 'classnames';
import { ButtonOutlinePrimary, ButtonPrimary } from '@lambdacurry/component-library';
import { Card, CardActions, CardHeader, CardSection } from 'lib/components';
import { useOrdersQuery, useUpdateOrderMutation } from 'lib/home/generated/queries';
import { OrdersQuery } from 'lib/home/generated/types/api';
import { DefaultLayout } from '../../../components';

const CancelPage: FC = () => {
  const queryClient = useQueryClient();
  const { data } = useOrdersQuery();
  const currentOrder = data?.me?.subscription?.current_order;

  const { mutate: mutateOrder } = useUpdateOrderMutation({
    onSuccess: ({ updateSubscriptionOrder }) => {
      queryClient.setQueryData(['Orders'], (ordersQuery: OrdersQuery) => {
        ordersQuery.me.subscription.current_order = {
          ...ordersQuery.me.subscription.current_order,
          ...updateSubscriptionOrder
        };
        return ordersQuery;
      });

      navigate('/');
    }
  });

  const handleSkipCurrentOrder = () =>
    mutateOrder({ updateSubscriptionOrderInput: { id: currentOrder.id, skip: true } });

  return (
    <DefaultLayout backTo="/account" className={classNames('account-dashboard')}>
      <Card>
        <CardSection>
          <CardHeader>
            <h3>Hey, One Second!</h3>
          </CardHeader>

          <p>Did you know you can skip your boxes?</p>

          <CardActions className="mt-16">
            <ButtonPrimary onClick={handleSkipCurrentOrder}>Yes, skip my next box</ButtonPrimary>
            <ButtonOutlinePrimary as={buttonProps => <Link {...buttonProps} to="/account/cancel/feedback" />}>
              No, cancel my subscription
            </ButtonOutlinePrimary>
          </CardActions>
        </CardSection>
      </Card>
    </DefaultLayout>
  );
};

export default CancelPage;
